import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Pageable} from '../../models/common/pageable.model';
import {PigletArticleListInfo} from '../../models/article/article-list-info.model';
import {Observable} from 'rxjs';
import {PigletEditArticle} from '../../models/article/piglet-edit-article.model';

@Injectable({
  providedIn: 'root'
})
export class PigletArticleService {

  private readonly baseUrl = `${environment.backend.url}/api/piglet/article/v1`;

  constructor(private readonly http: HttpClient) { }

  public getArticle(idArticle: number, language: string = 'pt-br'): Observable<PigletArticleListInfo> {
    return this.http.get<PigletArticleListInfo>(`${this.baseUrl}/id/${idArticle}`, {params: {language}});
  }

  public editArticle(article: PigletEditArticle) {
    return this.http.post<PigletArticleListInfo>(`${this.baseUrl}/edit`, article);
  }

  public getArticlesByCategory(type: number = 1, page: number = 0, ipp: number = 5, locale: string = 'pt-br') {
    let params = new HttpParams()
      .set('type', type.toString())
      .set('page', page.toString())
      .set('ipp', ipp.toString())
      .set('locale', locale);

    return this.http.get<Pageable<PigletArticleListInfo>>(`${this.baseUrl}/by-category`, { params });
  }

  public changeVisibility(idArticle: number, visibility: boolean) {
    let params = new HttpParams()
      .set('idArticle', idArticle.toString())
      .set('isVisible', visibility.toString());
    return this.http.patch(`${this.baseUrl}/toggle-visibility/${idArticle}`, {}, { params });
  }

  public changePublishState(idArticle: number, publishState: boolean) {
    let params = new HttpParams()
      .set('idArticle', idArticle.toString())
      .set('isPublished', publishState.toString());
    return this.http.patch(`${this.baseUrl}/toggle-pubish-state/${idArticle}`, {}, { params });
  }
}
